export class FullscreenLoaderModel {
  isVisible: boolean = false;
  loaderType?: string;
  contentfulMessageKey?: string;
  contentfulBody?: string;
}
